// /src/wsRecovery/wsRecoveryManager.js

import { startSleepyTick } from "./sleepyTick";
import { resumeAll } from "./wsResume";

/**
 * We temporarily block destructive token-refresh logic after a wake/network-freeze.
 * Example: if PC wakes while offline, axios would get 401 → logout.
 * resumeSafeUntil prevents that for a short window.
 */
let resumeSafeUntil = 0;
let initialized = false;

/**
 * Start a short protection window (ex: 3000ms)
 */
function startResumeSafeWindow(durationMs = 3000) {
  resumeSafeUntil = Date.now() + durationMs;
  console.log(
    `[WS Recovery] ⏳ resumeSafe active for ${durationMs}ms (until ${resumeSafeUntil})`
  );
}

/**
 * Called by axiosInterceptor to check if logout/401 actions should be suppressed.
 */
export function isResumeSafe() {
  return Date.now() < resumeSafeUntil;
}

export function initWsRecovery() {
  if (initialized) return;
  initialized = true;

  // start detection of browser sleep/wake
  startSleepyTick(({ type, gap }) => {
    console.warn("[WS Recovery] 💤 Sleep/wake detected, gap =", gap);

    // enable safe window BEFORE reconnect logic
    startResumeSafeWindow(3000);

    // resume all registered sockets
    resumeAll();
  });

  console.log("[WS Recovery] Manager initialized");
}
